import React, { useEffect, useMemo, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

/** First-page PDF thumbnail fitted inside the evidence tile. */
export default function EvidencePdfThumb({ fileUrl }) {
  const wrapRef = useRef(null);
  const [failed, setFailed] = useState(false);
  const [box, setBox] = useState({ w: 0, h: 0 });
  const [pageAspect, setPageAspect] = useState(0);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      const { width, height } = entry.contentRect;
      setBox({
        w: Math.max(0, Math.floor(width)),
        h: Math.max(0, Math.floor(height)),
      });
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const pageWidth = useMemo(() => {
    if (!box.w || !box.h) return 0;
    if (!pageAspect) return box.w;
    const widthLimited = box.w;
    const heightLimited = box.h * pageAspect;
    return Math.max(1, Math.floor(Math.min(widthLimited, heightLimited)));
  }, [box, pageAspect]);

  if (!fileUrl || failed) {
    return (
      <span className="epsf-destroy-evidence-tile__doc epsf-destroy-evidence-tile__doc--pdf">
        PDF
      </span>
    );
  }

  return (
    <div ref={wrapRef} className="epsf-destroy-evidence-tile__pdf-doc">
      {pageWidth > 0 ? (
        <Document
          file={fileUrl}
          loading={
            <span className="epsf-destroy-evidence-tile__doc epsf-destroy-evidence-tile__doc--pdf">
              …
            </span>
          }
          onLoadSuccess={async (pdf) => {
            try {
              const page = await pdf.getPage(1);
              const viewport = page.getViewport({ scale: 1 });
              const aspect =
                viewport?.width && viewport?.height
                  ? viewport.width / viewport.height
                  : 0;
              if (aspect > 0) setPageAspect(aspect);
            } catch {
              setFailed(true);
            }
          }}
          onLoadError={() => setFailed(true)}
        >
          <Page
            pageNumber={1}
            width={pageWidth}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            className="epsf-destroy-evidence-tile__pdf-page"
          />
        </Document>
      ) : null}
    </div>
  );
}
